"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ironProviderConfig = void 0;
exports.ironProviderConfig = {
    name: 'mining-iron',
    fullname: 'Iron Extractor',
    description: 'Extracts iron ore from stones.',
    type: 'mining',
    width: 1,
    height: 1,
    levelMax: 4,
    canBeDisabled: true,
    requiredTechnology: 'ores',
    levels: [
        { level: 0, constructionCosts: {}, time: 100, provides: { 'iron-ore': 1 }, costs: { stone: 4 }, stores: {} },
        { level: 1, constructionCosts: { iron: 10, copper: 10 }, time: 30, provides: { 'iron-ore': 1 }, costs: { stone: 3 }, stores: {} },
        { level: 2, constructionCosts: { iron: 30, copper: 30 }, time: 10, provides: { 'iron-ore': 1 }, costs: { stone: 3 }, stores: {} },
        { level: 3, constructionCosts: { iron: 50, copper: 50 }, time: 3, provides: { 'iron-ore': 1 }, costs: { stone: 3 }, stores: {} },
        { level: 4, constructionCosts: { iron: 100, copper: 100, gold: 100 }, time: 1, provides: { 'iron-ore': 5 }, costs: { stone: 12 }, stores: {} },
    ],
};



//////////////////
// WEBPACK FOOTER
// ../engine/dist/config/buildings/ironprovider.js
// module id = dDfj
// module chunks = 0